import React, { Component } from "react";
import { BrowserRouter as Router, Route, Redirect, Switch } from "react-router-dom"; // 导入BrowserRouter

// 组件导入（确保路径正确）
import Home from "./Puerta";
import Politica from "./Page/suyoDatos/politica";
import Terminos from "./Page/suyoDatos/terminos";
import Datos from "@/Page/common/datos";
import ErrorInfo from "./Page/ErrorInfo";
import FraudPrevention from "@/Page/common/fraud.jsx";
import PhoneLost from "@/Page/common/phoneLost.jsx";
import Cupones from "./Page/cupones";
import Contrato from "./Page/juicio/contrato.jsx";

class App extends Component {
  state={
    isBgWhite: false
  }
  componentDidMount() {
    window.addEventListener("scroll", this.bindScroll);
  }
   bindScroll = (event) => {

    const scrollTop =
      (event.srcElement ? event.srcElement.documentElement.scrollTop : false) ||
      window.pageYOffset ||
      (event.srcElement ? event.srcElement.body.scrollTop : 0);

    if (scrollTop > 0) {
      this.setState({
        isBgWhite: true,
      });
    } else {
      this.setState({
        isBgWhite: false,
      });
    }
  }
  render() {
    const {isBgWhite} = this.state
    return (
      <Router> {/* 使用BrowserRouter */}
        <Switch>
          {/* 基础路由 */}
          <Route exact path="/" render={(props) => <Home {...props} isBgWhite={isBgWhite}/>}/>
          <Route exact path="/download" render={(props) => <Home {...props} isBgWhite={isBgWhite}/>} />
          <Route exact path="/errorInfo" component={ErrorInfo} />
          
          {/* 政策和条款路由 */}
          <Route exact path="/politica" render={(props) => <Politica {...props} isBgWhite={isBgWhite} />} />
          <Route exact path="/terminos" render={(props) => <Terminos {...props} isBgWhite={isBgWhite} />} />
          <Route exact path="/juicio/contrato" component={Contrato} />
          
          {/* 带参数的政策和条款路由 */}
          <Route exact path="/politicamexc" render={(props) => <Politica {...props} suyo={2} />} />
          <Route exact path="/terminosmexc" render={(props) => <Terminos {...props} suyo={2} />} />
          <Route exact path="/politicasuyo" render={(props) => <Politica {...props} suyo={1} />} />
          <Route exact path="/terminossuyo" render={(props) => <Terminos {...props} suyo={1} />} />
          
          {/* 数据相关路由 */}
          <Route exact path="/suyodatos" component={Datos} />
          <Route exact path="/suyotomexc" render={(props) => <Datos {...props} suyo={1} />} />
          <Route exact path="/mexctosuyo" render={(props) => <Datos {...props} suyo={2} />} />
          
          {/* 欺诈预防和手机丢失相关路由 */}
          <Route exact path="/mexcFraudPrevention"  render={(props) => <FraudPrevention {...props} suyo={2} />} />
          <Route exact path="/suyoFraudPrevention" render={(props) => <FraudPrevention {...props} suyo={1} />} />
          <Route exact path="/mexcPhoneLost" render={(props) => <PhoneLost {...props} suyo={2} />} />
          <Route exact path="/suyoPhoneLost" render={(props) => <PhoneLost {...props} suyo={1} />} />
          
          {/* 优惠券路由 */}
          <Route exact path="/cuponesDesc" component={Cupones} />
          
          {/* 404重定向（确保在Switch的最后） */}
          <Route path="*" render={() => <Redirect to="/" />} />
        </Switch>
      </Router>
    );
  }
}

export default App;